
    import Vue from 'vue';
    export default {
      scrollToTop: true,
      head() {
        return {
          title: this.title,
          meta: [{
              hid: 'og:title',
              property: 'og:title',
              content: this.title
            },
            {
              hid: 'twitter:title',
              property: 'twitter:title',
              content: this.title
            },
            {
            hid: 'description',
            name: 'description',
            content: 'Explore the full lyrics of Aarti "Aarti Dyanraja Mahakaivalyteja" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'og:description',
            property: 'og:description',
            content: 'Explore the full lyrics of Aarti "Aarti Dyanraja Mahakaivalyteja" in both Marathi and English, with an option to switch between the two languages.'
          },
          {
            hid: 'twitter:description',
            property: 'twitter:description',
            content: 'Aarti Dyanraja Mahakaivalyteja, Mahakaivalyteja Aarti, Aarti for Dyanraja, Maharaja aarti, आरती ज्ञानराजा, ज्ञानदेवाची आरती, आरती ज्ञानराजा महाकैवल्यतेजा'
          },
          {
            hid: 'keywords',
            name: 'keywords',
            content: 'Aarti Dyanraja Mahakaivalyteja, Mahakaivalyteja Aarti, Aarti for Dyanraja, Dyanraja prayers, devotional aarti, Aarti lyrics, Maharaj Aarti, Dyanraja Bhajan, Aarti in Marathi, Mahakaivalyteja devotional aarti, आरती ज्ञानराजा, aarti dnyanraja lyrics in marathi, aarti dnyanraja lyrics in english, आरती ज्ञानराजा aarti'
          },
          {
            hid: 'image',
            property: 'image',
            content: this.$config.siteUrl + '/img/aarti/dyanraja.webp'
          },
          {
            hid: 'og:image',
            property: 'og:image',
            content: this.$config.siteUrl + '/img/aarti/dyanraja.webp'
          },
          ],
        }
      },
    
       components: {
        },
        data() {
          return {
            title: 'Aarti Dyanraja Mahakaivalyteja | Aarti Dyanraja - आरती ज्ञानराजा महाकैवल्यतेजा(ज्ञानदेवाची आरती)',
            langauageMarathi: true
          }
        },
        layout: 'detailsPage-withoutFooter',
    
        jsonld() {
    return {
      '@context': 'https://schema.org',
      "@graph": [{
        "@type": "Article",
        "mainEntityOfPage": {
          "@type": "WebPage",
          "@id": "https://goa.app/aarti/dyanraja"
        },
        "headline": "Aarti Dyanraja Mahakaivalyteja - आरती ज्ञानराजा महाकैवल्यतेजा(ज्ञानदेवाची आरती)",
        "name" : "Aarti Dyanraja Mahakaivalyteja - Aarti Dyanraja",
        "description": "Explore the full lyrics of Aarti 'Aarti Dyanraja Mahakaivalyteja' in both Marathi and English, with an option to switch between the two languages.",
        "image": this.$config.siteUrl + '/img/aarti/dyanraja.webp',  
        "author": {
          "@type": "Organization",
          "name": "Goa App",
          "url": "https://goa.app"
        },  
        "publisher": {
          "@type": "Organization",
          "name": "Goa App",
          "logo": {
            "@type": "ImageObject",
            "url": "https://goa.app/android-chrome-384x384.png"
          }
        },
        "datePublished": "2024-10-10T08:00:00+08:00",
        "dateModified": "2024-10-10T09:20:00+08:00"
      },]}
    }, 
    
        computed: {
    
        },
        methods:{
        changeLanguage:function () {
          this.langauageMarathi = !this.langauageMarathi
        }
      }
    
      }
    